import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { LogoEmailRenderer } from "./email";
import type { LogoBlockProps } from "./types";

export function LogoEditorRenderer(props: LogoBlockProps) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <LogoEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
